import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

export const APP_HEADER_HEIGHT = 56;

export default function AppHeader({ title, onBack, right, showBack }) {
  const back = showBack !== false && typeof onBack === 'function';

  return (
    <View style={[styles.header, !back && styles.headerFlush]}>
      {back ? (
        <TouchableOpacity style={styles.headerSide} onPress={onBack} hitSlop={8}>
          <Ionicons name="arrow-back" size={22} color="#1E293B" />
        </TouchableOpacity>
      ) : null}
      <Text style={styles.headerTitle} numberOfLines={1}>{title}</Text>
      {right ? <View style={styles.headerRight}>{right}</View> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    height: APP_HEADER_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 12,
    paddingLeft: 8,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  headerFlush: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  headerSide: {
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    flex: 1,
    textAlign: 'left',
    fontFamily: 'Poppins-Medium',
    fontSize: 16,
    fontWeight: '500',
    color: '#1E293B',
    includeFontPadding: false,
  },
  headerRight: {
    minWidth: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
